import type { ActivatedRoute } from '@angular/router';
import { loadBoolFilterFromGetParams, loadIntFilterFromGetParams, loadStringFilterFromGetParams } from '../reporting-core/utils';

export enum ChallengeStatus {
  draft = 'DRA',
  active = 'ACT',
  retired = 'RET'
}

export interface Challenge {
  id: number;
  url: string;
  name: string;
  status: ChallengeStatus;
  description: string;
  details: string;
  goal: number;
  auto_add_new_customers: boolean;
  auto_add_on_check_in: boolean;
  hide_in_climber_app: boolean;
  availability_start?: string;
  availability_end?: string;
  challenge_start?: string;
  challenge_end?: string;
  challenge_duration_days?: string;
  will_prompt_for_prize: boolean;
  reward_instructions: string;
  challenge_completion_association_id: number | null;
  challenge_completion_association_name: string | null;
  mailchimp_added_to_challenge_event_name: string;
  mailchimp_challenge_completed_event_name: string;
  mailchimp_challenge_expired_event_name: string;
  created_at: string;
  updated_at: string;
}

export interface CustomerChallenge {
  id: number;
  url: string;
  challenge_id: number;
  challenge_url: string;
  challenge_status: ChallengeStatus;
  challenge_name: string;
  challenge_goal: number;
  challenge_will_prompt_for_prize: boolean;
  challenge_reward_instructions: string;
  customer_id: number;
  customer_url: string;
  customer_first_name: string;
  customer_last_name: string;
  customer_birthday: string;
  customer_email: string;
  customer_home_location_id: number | null;
  customer_home_location_name: string | null;
  challenge_start?: string;
  challenge_end?: string;
  count: number;
  is_complete: boolean;
  prize_given: boolean;
  completed_at: string;
  challenge_has_ended: boolean;
  created_at: string;
  updated_at: string;
}

export interface ChallengeFilters {
  search?: string;
  status?: ChallengeStatus;
}

export interface CustomerChallengeFilters {
  challenge_id?: number;
  customer_id?: number;
  challenge_status_in?: string;
  home_location_id?: number;
  is_complete?: boolean;
  prize_given?: boolean;
}

export function loadChallengeFiltersFromGetParams(activatedRoute: ActivatedRoute): ChallengeFilters {
  const filters: ChallengeFilters = {};

  const initialQPs = activatedRoute.snapshot.queryParamMap;

  loadStringFilterFromGetParams(filters, 'search', initialQPs);
  loadStringFilterFromGetParams(filters, 'status', initialQPs);

  return filters;
}

export function loadCustomerChallengeFiltersFromGetParams(activatedRoute: ActivatedRoute): CustomerChallengeFilters {
  const filters: CustomerChallengeFilters = {};

  const initialQPs = activatedRoute.snapshot.queryParamMap;

  loadIntFilterFromGetParams(filters, 'challenge_id', initialQPs);
  loadIntFilterFromGetParams(filters, 'customer_id', initialQPs);
  loadStringFilterFromGetParams(filters, 'challenge_status_in', initialQPs);
  loadIntFilterFromGetParams(filters, 'home_location_id', initialQPs);
  loadBoolFilterFromGetParams(filters, 'is_complete', initialQPs);
  loadBoolFilterFromGetParams(filters, 'prize_given', initialQPs);

  return filters;
}

export function getChallengeStatusDisplay(status: ChallengeStatus) {
  switch (status) {
    case ChallengeStatus.draft:
      return 'Draft';
    case ChallengeStatus.active:
      return 'Active';
    case ChallengeStatus.retired:
      return 'Retired';
    default:
      return 'Unknown';
  }
}
